module.exports = __webpack_public_path__ + "static/media/handwork.05e6ec74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/handwork.jpg
// module id = 823
// module chunks = 3